import { render, staticRenderFns } from "./Inscribed.vue?vue&type=template&id=31b2199b"
import script from "./Inscribed.vue?vue&type=script&lang=js"
export * from "./Inscribed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports